export const shadows = {
  none: 'none',
  l: '0px 16px 32px rgba(0, 0, 0, 0.08)',
  m: '0px 8px 16px rgba(0, 0, 0, 0.08)',
  s: '0px 4px 8px rgba(0, 0, 0, 0.08)',
  xs: '0px 2px 4px rgba(0, 0, 0, 0.08)',
};
